<template>
  <div class="modal-backdrop">
    <div class="modal-content">
      <h5 class="text-start">Line: <i> {{ gunData.line_name }}</i></h5>
      <h5 class="text-start">Hopper: <i> {{ gunData.hopper_name }}</i></h5>
      <h5 class="text-start">Recipe <i> {{ gunData.recipe_name }}</i> Updated</h5>

      <div class="table-responsive">
        <table class="table text-center table-sm">
          <thead>
            <tr>
              <th class="small">Gun Name</th>
              <th class="small">Old Powder Amount Setting</th>
              <th class="small">New Powder Amount Setting</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="gun in gunData.gun_data" :key="gun.gun_index"
                :class="{
                  'table-success': gun.validation_status === 'valid' || gun.recipe_diagnosis === 'success',
                  'table-warning': gun.validation_status === 'change venturi diameter',
                  'table-danger': gun.validation_status === 'rejected' || gun.recipe_diagnosis === 'failure',
                }">
              <td class="small">{{ gun.gun_name }}</td>
              <td class="small">{{ gun.old_powder_amount_setting != null ? gun.old_powder_amount_setting.toFixed(1) : '-'}}</td>
              <td class="small">
                <span>
                  {{ gun.new_powder_amount_setting != null ? gun.new_powder_amount_setting.toFixed(1) : '-' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="color-legend mb-3">
          <div class="legend-item">
            <span class="color-box table-success"></span>
            <span>Valid</span>
          </div>
          <div class="legend-item">
            <span class="color-box table-warning"></span>
            <span>Change Venturi</span>
          </div>
          <div class="legend-item">
            <span class="color-box table-danger"></span>
            <span>Service</span>
          </div>
        </div>
      </div>
      <div class="actions" style="justify-content: center;">
        <button
          :disabled="recipe.recipe_index <= 0"
          class="btn accept"
          :class="{ 'btn-disabled': recipe.recipe_index <= 0 }"
          @click="previousRecipe">
          Previous Recipe
        </button>
        <button
          :disabled="recipe.recipe_index >= totalNumberOfRecipes - 1"
          class="btn accept"
          :class="{ 'btn-disabled': recipe.recipe_index >= totalNumberOfRecipes - 1 }"
          @click="nextRecipe">
          Next Recipe
        </button>
      </div>
      <div class="actions">
        <button class="btn btn-gray bg-gradient-gray" @click="goBack">Close</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "RecipesReviewModal",
  props: {
    recipe: {
      type: Object,
      required: true,
    },
    gunData: {
      type: Object,
      required: true,
    },
    totalNumberOfRecipes: {
      type: Number,
      required: true,
    },
  },
  emits: [
    'validated',
  ],
  methods: {
    goBack() {
      this.$emit('validated', { status: 'go_back' });
    },
    nextRecipe() {
      this.$emit('validated', { status: 'next' });
    },
    previousRecipe() {
      this.$emit('validated', { status: 'previous' });
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
  overflow-y: auto;
  inset: 0;
}
.modal-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 800px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}
.actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 15px;
}
.btn {
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  min-width: 200px;
}
.accept {
  background: #4caf50;
  color: white;
}
.reject {
  background: #f44336;
  color: white;
}

.table-success {
  background-color: #d4edda;
}
.table-warning {
  background-color: #fff3cd;
}
.table-danger {
  background-color: #f8d7da;
}

.color-legend {
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 0.9rem;
}

.legend-item {
  display: flex;
  align-items: center;
}

.color-box {
  width: 20px;
  height: 20px;
  display: inline-block;
  border-radius: 3px;
  margin-right: 6px;
  border: 1px solid #ccc;
}

.btn-disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.btn-disabled:hover {
  background-color: #ccc;
  cursor: not-allowed;
}
.btn-disabled:active {
  background-color: #ccc;
  cursor: not-allowed;
}
.btn-disabled:focus {
  outline: none;
}
.btn-disabled:focus-visible {
  outline: none;
}
</style>
